const OrdersAndSchedule = () => import("@/pages/ordersAndSchedule/index");
const OrderAndScheduleDetails = () =>
  import("@/pages/ordersAndSchedule/order-details");

const MODULE = "ordersAndSchedule";

const authenticatedRoles = [
  "superadmin",
  "admin",
  "operations",
  "vendor_manager",
  "gardener",
  "gardener_pro",
  "growth",
];

const routes = () => {
  return [
    {
      path: "/orders-and-schedule",
      name: "ordersAndSchedule.index",
      component: OrdersAndSchedule,
      meta: {
        module: MODULE,
        permission: authenticatedRoles,
        layout: "app",
      },
    },

    {
      path: "/orders-and-schedule-details/:id",
      name: "ordersAndSchedule.details",
      component: OrderAndScheduleDetails,
      meta: {
        module: MODULE,
        permission: authenticatedRoles,
        layout: "app",
      },
    },
  ];
};

export default routes();
